import http from '../http';

const AB_TEST_REPORT = '/exp_report';
const CAMPAIGN_REPORT = '/campaignReport';

export default {
  // abtest 报表内容
  getAbtestReportTemplateContent(data: Record<any, any>) {
    return http.post(`${AB_TEST_REPORT}/template_content`, data);
  },
  /** 常规活动/周期活动 - 获取邮件详情 */
  getCampaignMailDetail(data: Record<any, any>) {
    return http.post(`${CAMPAIGN_REPORT}/detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
